<template>
  <div class="w-100">
    Job COMPLETED
    <job-object :job-number="activity.job_id" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
